import React from 'react'
import { Row } from 'react-bootstrap'
import Item from '../list-item'
import Spinner from '../../common/spinner-container'
import useUserGoals from '../../../hooks/use-user-goals'

const GoalsList = ({
    userId,
}) => {

    const { isBusy, userGoals } = useUserGoals({ userId })
    const goals = userGoals

    if (isBusy) {
        return (<Spinner />)
    }

    if (!goals.length) {
        return (<div className='text-center text-muted'>There are no goals</div>)
    }

    const renderItem = (item, key) => {
        return (
            <Item key={key} goal={item} />
        )
    }

    return (
        <div>
            {goals.map(renderItem)}
        </div>
    )
}

export default GoalsList